import useTrial from "./index";

const {
  isTiming,
  startTrialTimer,
  stopTrialTimer,
  showTrial,
  changeTrialDialog,
} = useTrial();

export {
  isTiming,
  startTrialTimer,
  stopTrialTimer,
  showTrial,
  changeTrialDialog,
};
